import AccountDetailsPage from "components/pages/AccountDetailsPage"; 

export default function CaptureQuickToursAccountDetails(props) {
    return <AccountDetailsPage />
}